export default {
  subtitle: "深入了解CBAM合规、碳排放计算和行业最佳实践",
  no_posts: "暂无文章",
  loading: "加载中...",
  read_time: "{minutes}分钟阅读",
  minute: "分钟",
  share: "分享:",
  back_to_list: "返回博客列表",
  article_not_found: "文章未找到",
  article_not_found_desc: "抱歉，您查找的文章不存在",
  cta_title: "准备好开始您的CBAM合规之旅了吗？",
  cta_subtitle: "立即试用TaxEcoBit，轻松生成符合欧盟标准的碳排放报告",
  cta_button: "立即试用",
};
